import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


const Blog = () => {
    const [BlogData, setBlogData] = useState([]);
    const {t} = useTranslation();
  
    useEffect(() => {
      const fetchData = async () => {
        const response = await axios.get(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/blog_list"
        );
        setBlogData(response.data.data);
      };
  
      fetchData();
    }, []);


  return (
    <section>
      
      <div className="container spad blog-section">
        <div className="breadcrumb-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="breadcrumb-text"
                  data-aos="fade-down"
                  data-aos-duration={3000}
                >
                  <h1 style={{fontSize:"44px"}}>Our Blogs</h1>
                  <div className="bt-option">
                    <Link to="/">{t("home")}</Link>
                    <span>{t("blog")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {BlogData.map((post, index) => (
            <div className="col-lg-4" key={index}>
              <div className="card shadow-sm mb-4">
                <div className="card-img-top">
                  <img src={`https://cyberathon.com/silverapartment/${post.blog_image}`} loading="lazy" alt="Blog" />
                </div>
                <div className="card-body">
                  <p className="text-muted">
                    By Admin | {post.blog_date}
                  </p>
                  <h2 className="card-title mb-4" style={{fontSize:"30px"}}>{post.blog_head}</h2>
                
                <Link to={`/blog-detail/${post.blog_id}`} className="blog-read-more">
                Read More
                </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
